export default "__VITE_ASSET__DyrWc$RS__"